import { observer } from 'mobx-react-lite'
import PageLayout from '../PageLayout'
import appStore from '../../storage/AppStore'

const Contacts = () => {
  return (
    <PageLayout
      header={<h4 className="mb-0 text-center">{appStore.tr.contacts}</h4>}
    >
      <div
        className="flex align-items-center justify-content-center"
        style={{ minHeight: '60vh' }}
      >
        <a
          href="https://t.me/club1_support"
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg font-semibold text-blue-500"
          style={{ textDecoration: 'none' }}
        >
          <i className={"pi pi-telegram"} style={{ fontSize: '7.5rem' }}/>
        </a>
      </div>
    </PageLayout>
  )
}

export default observer(Contacts)
